module.exports = __webpack_public_path__ + "media/images/country_flags/tc-c7e3c67ffcda1ca9073caef141ddb6e5.png";